/* */ 
"use strict";
var __extends = (this && this.__extends) || function(d, b) {
  for (var p in b)
    if (b.hasOwnProperty(p))
      d[p] = b[p];
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var core_1 = require('@angular/core');
var core_private_1 = require('../core_private');
var lang_1 = require('./facade/lang');
var exceptions_1 = require('./facade/exceptions');
var collection_1 = require('./facade/collection');
var selector_1 = require('./selector');
var util_1 = require('./util');
var url_resolver_1 = require('./url_resolver');
var HOST_REG_EXP = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))$/g;
var CompileMetadataWithIdentifier = (function() {
  function CompileMetadataWithIdentifier() {}
  Object.defineProperty(CompileMetadataWithIdentifier.prototype, "identifier", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  return CompileMetadataWithIdentifier;
}());
exports.CompileMetadataWithIdentifier = CompileMetadataWithIdentifier;
var CompileMetadataWithType = (function(_super) {
  __extends(CompileMetadataWithType, _super);
  function CompileMetadataWithType() {
    _super.apply(this, arguments);
  }
  Object.defineProperty(CompileMetadataWithType.prototype, "type", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CompileMetadataWithType.prototype, "identifier", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  return CompileMetadataWithType;
}(CompileMetadataWithIdentifier));
exports.CompileMetadataWithType = CompileMetadataWithType;
function metadataFromJson(data) {
  return _COMPILE_METADATA_FROM_JSON[data['class']](data);
}
exports.metadataFromJson = metadataFromJson;
var CompileIdentifierMetadata = (function() {
  function CompileIdentifierMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        runtime = _b.runtime,
        name = _b.name,
        moduleUrl = _b.moduleUrl,
        prefix = _b.prefix,
        value = _b.value;
    this.runtime = runtime;
    this.name = name;
    this.prefix = prefix;
    this.moduleUrl = moduleUrl;
    this.value = value;
  }
  CompileIdentifierMetadata.fromJson = function(data) {
    var value = lang_1.isArray(data['value']) ? _arrayFromJson(data['value'], metadataFromJson) : _objFromJson(data['value'], metadataFromJson);
    return new CompileIdentifierMetadata({
      name: data['name'],
      prefix: data['prefix'],
      moduleUrl: data['moduleUrl'],
      value: value
    });
  };
  CompileIdentifierMetadata.prototype.toJson = function() {
    var value = lang_1.isArray(this.value) ? _arrayToJson(this.value) : _objToJson(this.value);
    return {
      'class': 'Identifier',
      'name': this.name,
      'moduleUrl': this.moduleUrl,
      'prefix': this.prefix,
      'value': value
    };
  };
  Object.defineProperty(CompileIdentifierMetadata.prototype, "identifier", {
    get: function() {
      return this;
    },
    enumerable: true,
    configurable: true
  });
  return CompileIdentifierMetadata;
}());
exports.CompileIdentifierMetadata = CompileIdentifierMetadata;
var CompileDiDependencyMetadata = (function() {
  function CompileDiDependencyMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        isAttribute = _b.isAttribute,
        isSelf = _b.isSelf,
        isHost = _b.isHost,
        isSkipSelf = _b.isSkipSelf,
        isOptional = _b.isOptional,
        isValue = _b.isValue,
        query = _b.query,
        viewQuery = _b.viewQuery,
        token = _b.token,
        value = _b.value;
    this.isAttribute = lang_1.normalizeBool(isAttribute);
    this.isSelf = lang_1.normalizeBool(isSelf);
    this.isHost = lang_1.normalizeBool(isHost);
    this.isSkipSelf = lang_1.normalizeBool(isSkipSelf);
    this.isOptional = lang_1.normalizeBool(isOptional);
    this.isValue = lang_1.normalizeBool(isValue);
    this.query = query;
    this.viewQuery = viewQuery;
    this.token = token;
    this.value = value;
  }
  CompileDiDependencyMetadata.fromJson = function(data) {
    return new CompileDiDependencyMetadata({
      token: _objFromJson(data['token'], CompileTokenMetadata.fromJson),
      query: _objFromJson(data['query'], CompileQueryMetadata.fromJson),
      viewQuery: _objFromJson(data['viewQuery'], CompileQueryMetadata.fromJson),
      value: data['value'],
      isAttribute: data['isAttribute'],
      isSelf: data['isSelf'],
      isHost: data['isHost'],
      isSkipSelf: data['isSkipSelf'],
      isOptional: data['isOptional'],
      isValue: data['isValue']
    });
  };
  CompileDiDependencyMetadata.prototype.toJson = function() {
    return {
      'token': _objToJson(this.token),
      'query': _objToJson(this.query),
      'viewQuery': _objToJson(this.viewQuery),
      'value': this.value,
      'isAttribute': this.isAttribute,
      'isSelf': this.isSelf,
      'isHost': this.isHost,
      'isSkipSelf': this.isSkipSelf,
      'isOptional': this.isOptional,
      'isValue': this.isValue
    };
  };
  return CompileDiDependencyMetadata;
}());
exports.CompileDiDependencyMetadata = CompileDiDependencyMetadata;
var CompileProviderMetadata = (function() {
  function CompileProviderMetadata(_a) {
    var token = _a.token,
        useClass = _a.useClass,
        useValue = _a.useValue,
        useExisting = _a.useExisting,
        useFactory = _a.useFactory,
        deps = _a.deps,
        multi = _a.multi;
    this.token = token;
    this.useClass = useClass;
    this.useValue = useValue;
    this.useExisting = useExisting;
    this.useFactory = useFactory;
    this.deps = lang_1.normalizeBlank(deps);
    this.multi = lang_1.normalizeBool(multi);
  }
  CompileProviderMetadata.fromJson = function(data) {
    return new CompileProviderMetadata({
      token: _objFromJson(data['token'], CompileTokenMetadata.fromJson),
      useClass: _objFromJson(data['useClass'], CompileTypeMetadata.fromJson),
      useExisting: _objFromJson(data['useExisting'], CompileTokenMetadata.fromJson),
      useValue: _objFromJson(data['useValue'], CompileIdentifierMetadata.fromJson),
      useFactory: _objFromJson(data['useFactory'], CompileFactoryMetadata.fromJson),
      multi: data['multi'],
      deps: _arrayFromJson(data['deps'], CompileDiDependencyMetadata.fromJson)
    });
  };
  CompileProviderMetadata.prototype.toJson = function() {
    return {
      'class': 'Provider',
      'token': _objToJson(this.token),
      'useClass': _objToJson(this.useClass),
      'useExisting': _objToJson(this.useExisting),
      'useValue': _objToJson(this.useValue),
      'useFactory': _objToJson(this.useFactory),
      'multi': this.multi,
      'deps': _arrayToJson(this.deps)
    };
  };
  return CompileProviderMetadata;
}());
exports.CompileProviderMetadata = CompileProviderMetadata;
var CompileFactoryMetadata = (function() {
  function CompileFactoryMetadata(_a) {
    var runtime = _a.runtime,
        name = _a.name,
        moduleUrl = _a.moduleUrl,
        prefix = _a.prefix,
        diDeps = _a.diDeps,
        value = _a.value;
    this.runtime = runtime;
    this.name = name;
    this.prefix = prefix;
    this.moduleUrl = moduleUrl;
    this.diDeps = _normalizeArray(diDeps);
    this.value = value;
  }
  Object.defineProperty(CompileFactoryMetadata.prototype, "identifier", {
    get: function() {
      return this;
    },
    enumerable: true,
    configurable: true
  });
  CompileFactoryMetadata.fromJson = function(data) {
    return new CompileFactoryMetadata({
      name: data['name'],
      prefix: data['prefix'],
      moduleUrl: data['moduleUrl'],
      value: data['value'],
      diDeps: _arrayFromJson(data['diDeps'], CompileDiDependencyMetadata.fromJson)
    });
  };
  CompileFactoryMetadata.prototype.toJson = function() {
    return {
      'class': 'Factory',
      'name': this.name,
      'prefix': this.prefix,
      'moduleUrl': this.moduleUrl,
      'value': this.value,
      'diDeps': _arrayToJson(this.diDeps)
    };
  };
  return CompileFactoryMetadata;
}());
exports.CompileFactoryMetadata = CompileFactoryMetadata;
var CompileTokenMetadata = (function() {
  function CompileTokenMetadata(_a) {
    var value = _a.value,
        identifier = _a.identifier,
        identifierIsInstance = _a.identifierIsInstance;
    this.value = value;
    this.identifier = identifier;
    this.identifierIsInstance = lang_1.normalizeBool(identifierIsInstance);
  }
  CompileTokenMetadata.fromJson = function(data) {
    return new CompileTokenMetadata({
      value: data['value'],
      identifier: _objFromJson(data['identifier'], CompileIdentifierMetadata.fromJson),
      identifierIsInstance: data['identifierIsInstance']
    });
  };
  CompileTokenMetadata.prototype.toJson = function() {
    return {
      'value': this.value,
      'identifier': _objToJson(this.identifier),
      'identifierIsInstance': this.identifierIsInstance
    };
  };
  Object.defineProperty(CompileTokenMetadata.prototype, "runtimeCacheKey", {
    get: function() {
      if (lang_1.isPresent(this.identifier)) {
        return this.identifier.runtime;
      } else {
        return this.value;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CompileTokenMetadata.prototype, "assetCacheKey", {
    get: function() {
      if (lang_1.isPresent(this.identifier)) {
        return lang_1.isPresent(this.identifier.moduleUrl) && lang_1.isPresent(url_resolver_1.getUrlScheme(this.identifier.moduleUrl)) ? this.identifier.name + "|" + this.identifier.moduleUrl + "|" + this.identifierIsInstance : null;
      } else {
        return this.value;
      }
    },
    enumerable: true,
    configurable: true
  });
  CompileTokenMetadata.prototype.equalsTo = function(token2) {
    var rk = this.runtimeCacheKey;
    var ak = this.assetCacheKey;
    return (lang_1.isPresent(rk) && rk == token2.runtimeCacheKey) || (lang_1.isPresent(ak) && ak == token2.assetCacheKey);
  };
  Object.defineProperty(CompileTokenMetadata.prototype, "name", {
    get: function() {
      return lang_1.isPresent(this.value) ? util_1.sanitizeIdentifier(this.value) : this.identifier.name;
    },
    enumerable: true,
    configurable: true
  });
  return CompileTokenMetadata;
}());
exports.CompileTokenMetadata = CompileTokenMetadata;
var CompileTokenMap = (function() {
  function CompileTokenMap() {
    this._valueMap = new Map();
    this._values = [];
  }
  CompileTokenMap.prototype.add = function(token, value) {
    var existing = this.get(token);
    if (lang_1.isPresent(existing)) {
      throw new exceptions_1.BaseException("Can only add to a TokenMap! Token: " + token.name);
    }
    this._values.push(value);
    var rk = token.runtimeCacheKey;
    if (lang_1.isPresent(rk)) {
      this._valueMap.set(rk, value);
    }
    var ak = token.assetCacheKey;
    if (lang_1.isPresent(ak)) {
      this._valueMap.set(ak, value);
    }
  };
  CompileTokenMap.prototype.get = function(token) {
    var rk = token.runtimeCacheKey;
    var ak = token.assetCacheKey;
    var result;
    if (lang_1.isPresent(rk)) {
      result = this._valueMap.get(rk);
    }
    if (lang_1.isBlank(result) && lang_1.isPresent(ak)) {
      result = this._valueMap.get(ak);
    }
    return result;
  };
  CompileTokenMap.prototype.values = function() {
    return this._values;
  };
  Object.defineProperty(CompileTokenMap.prototype, "size", {
    get: function() {
      return this._values.length;
    },
    enumerable: true,
    configurable: true
  });
  return CompileTokenMap;
}());
exports.CompileTokenMap = CompileTokenMap;
var CompileTypeMetadata = (function() {
  function CompileTypeMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        runtime = _b.runtime,
        name = _b.name,
        moduleUrl = _b.moduleUrl,
        prefix = _b.prefix,
        isHost = _b.isHost,
        value = _b.value,
        diDeps = _b.diDeps;
    this.runtime = runtime;
    this.name = name;
    this.moduleUrl = moduleUrl;
    this.prefix = prefix;
    this.isHost = lang_1.normalizeBool(isHost);
    this.value = value;
    this.diDeps = _normalizeArray(diDeps);
  }
  CompileTypeMetadata.fromJson = function(data) {
    return new CompileTypeMetadata({
      name: data['name'],
      moduleUrl: data['moduleUrl'],
      prefix: data['prefix'],
      isHost: data['isHost'],
      value: data['value'],
      diDeps: _arrayFromJson(data['diDeps'], CompileDiDependencyMetadata.fromJson)
    });
  };
  Object.defineProperty(CompileTypeMetadata.prototype, "identifier", {
    get: function() {
      return this;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(CompileTypeMetadata.prototype, "type", {
    get: function() {
      return this;
    },
    enumerable: true,
    configurable: true
  });
  CompileTypeMetadata.prototype.toJson = function() {
    return {
      'class': 'Type',
      'name': this.name,
      'moduleUrl': this.moduleUrl,
      'prefix': this.prefix,
      'isHost': this.isHost,
      'value': this.value,
      'diDeps': _arrayToJson(this.diDeps)
    };
  };
  return CompileTypeMetadata;
}());
exports.CompileTypeMetadata = CompileTypeMetadata;
var CompileQueryMetadata = (function() {
  function CompileQueryMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        selectors = _b.selectors,
        descendants = _b.descendants,
        first = _b.first,
        propertyName = _b.propertyName,
        read = _b.read;
    this.selectors = selectors;
    this.descendants = lang_1.normalizeBool(descendants);
    this.first = lang_1.normalizeBool(first);
    this.propertyName = propertyName;
    this.read = read;
  }
  CompileQueryMetadata.fromJson = function(data) {
    return new CompileQueryMetadata({
      selectors: _arrayFromJson(data['selectors'], CompileTokenMetadata.fromJson),
      descendants: data['descendants'],
      first: data['first'],
      propertyName: data['propertyName'],
      read: _objFromJson(data['read'], CompileTokenMetadata.fromJson)
    });
  };
  CompileQueryMetadata.prototype.toJson = function() {
    return {
      'selectors': _arrayToJson(this.selectors),
      'descendants': this.descendants,
      'first': this.first,
      'propertyName': this.propertyName,
      'read': _objToJson(this.read)
    };
  };
  return CompileQueryMetadata;
}());
exports.CompileQueryMetadata = CompileQueryMetadata;
var CompileTemplateMetadata = (function() {
  function CompileTemplateMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        encapsulation = _b.encapsulation,
        template = _b.template,
        templateUrl = _b.templateUrl,
        styles = _b.styles,
        styleUrls = _b.styleUrls,
        ngContentSelectors = _b.ngContentSelectors;
    this.encapsulation = lang_1.isPresent(encapsulation) ? encapsulation : core_1.ViewEncapsulation.Emulated;
    this.template = template;
    this.templateUrl = templateUrl;
    this.styles = lang_1.isPresent(styles) ? styles : [];
    this.styleUrls = lang_1.isPresent(styleUrls) ? styleUrls : [];
    this.ngContentSelectors = lang_1.isPresent(ngContentSelectors) ? ngContentSelectors : [];
  }
  CompileTemplateMetadata.fromJson = function(data) {
    return new CompileTemplateMetadata({
      encapsulation: lang_1.isPresent(data['encapsulation']) ? core_private_1.VIEW_ENCAPSULATION_VALUES[data['encapsulation']] : data['encapsulation'],
      template: data['template'],
      templateUrl: data['templateUrl'],
      styles: data['styles'],
      styleUrls: data['styleUrls'],
      ngContentSelectors: data['ngContentSelectors']
    });
  };
  CompileTemplateMetadata.prototype.toJson = function() {
    return {
      'encapsulation': lang_1.isPresent(this.encapsulation) ? lang_1.serializeEnum(this.encapsulation) : this.encapsulation,
      'template': this.template,
      'templateUrl': this.templateUrl,
      'styles': this.styles,
      'styleUrls': this.styleUrls,
      'ngContentSelectors': this.ngContentSelectors
    };
  };
  return CompileTemplateMetadata;
}());
exports.CompileTemplateMetadata = CompileTemplateMetadata;
var CompileDirectiveMetadata = (function() {
  function CompileDirectiveMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        type = _b.type,
        isComponent = _b.isComponent,
        selector = _b.selector,
        exportAs = _b.exportAs,
        changeDetection = _b.changeDetection,
        inputs = _b.inputs,
        outputs = _b.outputs,
        hostListeners = _b.hostListeners,
        hostProperties = _b.hostProperties,
        hostAttributes = _b.hostAttributes,
        lifecycleHooks = _b.lifecycleHooks,
        providers = _b.providers,
        viewProviders = _b.viewProviders,
        queries = _b.queries,
        viewQueries = _b.viewQueries,
        template = _b.template;
    this.type = type;
    this.isComponent = isComponent;
    this.selector = selector;
    this.exportAs = exportAs;
    this.changeDetection = changeDetection;
    this.inputs = inputs;
    this.outputs = outputs;
    this.hostListeners = hostListeners;
    this.hostProperties = hostProperties;
    this.hostAttributes = hostAttributes;
    this.lifecycleHooks = _normalizeArray(lifecycleHooks);
    this.providers = _normalizeArray(providers);
    this.viewProviders = _normalizeArray(viewProviders);
    this.queries = _normalizeArray(queries);
    this.viewQueries = _normalizeArray(viewQueries);
    this.template = template;
  }
  CompileDirectiveMetadata.create = function(_a) {
    var _b = _a === void 0 ? {} : _a,
        type = _b.type,
        isComponent = _b.isComponent,
        selector = _b.selector,
        exportAs = _b.exportAs,
        changeDetection = _b.changeDetection,
        inputs = _b.inputs,
        outputs = _b.outputs,
        host = _b.host,
        lifecycleHooks = _b.lifecycleHooks,
        providers = _b.providers,
        viewProviders = _b.viewProviders,
        queries = _b.queries,
        viewQueries = _b.viewQueries,
        template = _b.template;
    var hostListeners = {};
    var hostProperties = {};
    var hostAttributes = {};
    if (lang_1.isPresent(host)) {
      collection_1.StringMapWrapper.forEach(host, function(value, key) {
        var matches = lang_1.RegExpWrapper.firstMatch(HOST_REG_EXP, key);
        if (lang_1.isBlank(matches)) {
          hostAttributes[key] = value;
        } else if (lang_1.isPresent(matches[1])) {
          hostProperties[matches[1]] = value;
        } else if (lang_1.isPresent(matches[2])) {
          hostListeners[matches[2]] = value;
        }
      });
    }
    var inputsMap = {};
    if (lang_1.isPresent(inputs)) {
      inputs.forEach(function(bindConfig) {
        var parts = util_1.splitAtColon(bindConfig, [bindConfig, bindConfig]);
        inputsMap[parts[0]] = parts[1];
      });
    }
    var outputsMap = {};
    if (lang_1.isPresent(outputs)) {
      outputs.forEach(function(bindConfig) {
        var parts = util_1.splitAtColon(bindConfig, [bindConfig, bindConfig]);
        outputsMap[parts[0]] = parts[1];
      });
    }
    return new CompileDirectiveMetadata({
      type: type,
      isComponent: lang_1.normalizeBool(isComponent),
      selector: selector,
      exportAs: exportAs,
      changeDetection: changeDetection,
      inputs: inputsMap,
      outputs: outputsMap,
      hostListeners: hostListeners,
      hostProperties: hostProperties,
      hostAttributes: hostAttributes,
      lifecycleHooks: lang_1.isPresent(lifecycleHooks) ? lifecycleHooks : [],
      providers: providers,
      viewProviders: viewProviders,
      queries: queries,
      viewQueries: viewQueries,
      template: template
    });
  };
  Object.defineProperty(CompileDirectiveMetadata.prototype, "identifier", {
    get: function() {
      return this.type;
    },
    enumerable: true,
    configurable: true
  });
  CompileDirectiveMetadata.fromJson = function(data) {
    return new CompileDirectiveMetadata({
      isComponent: data['isComponent'],
      selector: data['selector'],
      exportAs: data['exportAs'],
      type: lang_1.isPresent(data['type']) ? CompileTypeMetadata.fromJson(data['type']) : data['type'],
      changeDetection: lang_1.isPresent(data['changeDetection']) ? core_private_1.CHANGE_DETECTION_STRATEGY_VALUES[data['changeDetection']] : data['changeDetection'],
      inputs: data['inputs'],
      outputs: data['outputs'],
      hostListeners: data['hostListeners'],
      hostProperties: data['hostProperties'],
      hostAttributes: data['hostAttributes'],
      lifecycleHooks: data['lifecycleHooks'].map(function(hookValue) {
        return core_private_1.LIFECYCLE_HOOKS_VALUES[hookValue];
      }),
      template: lang_1.isPresent(data['template']) ? CompileTemplateMetadata.fromJson(data['template']) : data['template'],
      providers: _arrayFromJson(data['providers'], metadataFromJson),
      viewProviders: _arrayFromJson(data['viewProviders'], metadataFromJson),
      queries: _arrayFromJson(data['queries'], CompileQueryMetadata.fromJson),
      viewQueries: _arrayFromJson(data['viewQueries'], CompileQueryMetadata.fromJson)
    });
  };
  CompileDirectiveMetadata.prototype.toJson = function() {
    return {
      'class': 'Directive',
      'isComponent': this.isComponent,
      'selector': this.selector,
      'exportAs': this.exportAs,
      'type': lang_1.isPresent(this.type) ? this.type.toJson() : this.type,
      'changeDetection': lang_1.isPresent(this.changeDetection) ? lang_1.serializeEnum(this.changeDetection) : this.changeDetection,
      'inputs': this.inputs,
      'outputs': this.outputs,
      'hostListeners': this.hostListeners,
      'hostProperties': this.hostProperties,
      'hostAttributes': this.hostAttributes,
      'lifecycleHooks': this.lifecycleHooks.map(function(hook) {
        return lang_1.serializeEnum(hook);
      }),
      'template': lang_1.isPresent(this.template) ? this.template.toJson() : this.template,
      'providers': _arrayToJson(this.providers),
      'viewProviders': _arrayToJson(this.viewProviders),
      'queries': _arrayToJson(this.queries),
      'viewQueries': _arrayToJson(this.viewQueries)
    };
  };
  return CompileDirectiveMetadata;
}());
exports.CompileDirectiveMetadata = CompileDirectiveMetadata;
function createHostComponentMeta(componentType, componentSelector) {
  var template = selector_1.CssSelector.parse(componentSelector)[0].getMatchingElementTemplate();
  return CompileDirectiveMetadata.create({
    type: new CompileTypeMetadata({
      runtime: Object,
      name: componentType.name + "_Host",
      moduleUrl: componentType.moduleUrl,
      isHost: true
    }),
    template: new CompileTemplateMetadata({
      template: template,
      templateUrl: '',
      styles: [],
      styleUrls: [],
      ngContentSelectors: []
    }),
    changeDetection: core_1.ChangeDetectionStrategy.Default,
    inputs: [],
    outputs: [],
    host: {},
    lifecycleHooks: [],
    isComponent: true,
    selector: '*',
    providers: [],
    viewProviders: [],
    queries: [],
    viewQueries: []
  });
}
exports.createHostComponentMeta = createHostComponentMeta;
var CompilePipeMetadata = (function() {
  function CompilePipeMetadata(_a) {
    var _b = _a === void 0 ? {} : _a,
        type = _b.type,
        name = _b.name,
        pure = _b.pure,
        lifecycleHooks = _b.lifecycleHooks;
    this.type = type;
    this.name = name;
    this.pure = lang_1.normalizeBool(pure);
    this.lifecycleHooks = _normalizeArray(lifecycleHooks);
  }
  Object.defineProperty(CompilePipeMetadata.prototype, "identifier", {
    get: function() {
      return this.type;
    },
    enumerable: true,
    configurable: true
  });
  CompilePipeMetadata.fromJson = function(data) {
    return new CompilePipeMetadata({
      type: lang_1.isPresent(data['type']) ? CompileTypeMetadata.fromJson(data['type']) : data['type'],
      name: data['name'],
      pure: data['pure']
    });
  };
  CompilePipeMetadata.prototype.toJson = function() {
    return {
      'class': 'Pipe',
      'type': lang_1.isPresent(this.type) ? this.type.toJson() : null,
      'name': this.name,
      'pure': this.pure
    };
  };
  return CompilePipeMetadata;
}());
exports.CompilePipeMetadata = CompilePipeMetadata;
var _COMPILE_METADATA_FROM_JSON = {
  'Directive': CompileDirectiveMetadata.fromJson,
  'Pipe': CompilePipeMetadata.fromJson,
  'Type': CompileTypeMetadata.fromJson,
  'Provider': CompileProviderMetadata.fromJson,
  'Identifier': CompileIdentifierMetadata.fromJson,
  'Factory': CompileFactoryMetadata.fromJson
};
function _arrayFromJson(obj, fn) {
  return lang_1.isBlank(obj) ? null : obj.map(function(o) {
    return _objFromJson(o, fn);
  });
}
function _arrayToJson(obj) {
  return lang_1.isBlank(obj) ? null : obj.map(_objToJson);
}
function _objFromJson(obj, fn) {
  if (lang_1.isArray(obj))
    return _arrayFromJson(obj, fn);
  if (lang_1.isString(obj) || lang_1.isBlank(obj) || lang_1.isBoolean(obj) || lang_1.isNumber(obj))
    return obj;
  return fn(obj);
}
function _objToJson(obj) {
  if (lang_1.isArray(obj))
    return _arrayToJson(obj);
  if (lang_1.isString(obj) || lang_1.isBlank(obj) || lang_1.isBoolean(obj) || lang_1.isNumber(obj))
    return obj;
  return obj.toJson();
}
function _normalizeArray(obj) {
  return lang_1.isPresent(obj) ? obj : [];
}
